import React from 'react';

import { Button } from '@material-ui/core';

import styles from './JobAlertDialogText.module.scss';

interface JobAlertDialogTextProps {
  goToJobAlertPage?: () => void;
  closeDialog?: () => void;
}

export const JobAlertDialogText: React.FC<JobAlertDialogTextProps> = ({
  goToJobAlertPage,
  closeDialog,
}) => {
  return (
    <div data-testid="alert-dialog-max-limit-reached">
      <p className={styles.dialogDetail}>
        Please delete one of your existing alerts to save a new one.
      </p>
      <Button
        className={styles.dialogButton}
        fullWidth
        variant="contained"
        size="large"
        color="secondary"
        onClick={goToJobAlertPage}
      >
        Manage job alerts
      </Button>
      <Button
        className={styles.dialogButton}
        fullWidth
        size="large"
        color="secondary"
        onClick={closeDialog}
      >
        Cancel
      </Button>
    </div>
  );
};
